<template>
  <div>
      
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div
        class="section-title"
      >{{ $tc('edit') }} {{ $tc('distributor', 1) }} {{ $t('share') }} {{ $tc('type', 1) }}</div>
      <router-link
        class="btn-blue"
        to="distributor-share-type"
      >{{ $tc('distributor', 1) }} {{ $t('share') }} {{ $tc('type', 1) }} {{ $tc('list',2) }}</router-link>
    </div>
    <div class="white-wrapper">
      <form>
        <div class="row">
          <div class="col-3 mb-3">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  v-model="distributorShareType.dst_label"
                  type="text"
                  placeholder="."
                  name="sharelabel"
                  id="sharelabel"
                  v-validate="'required|alpha_spaces'"
                  v-b-tooltip.hover
                  :title="$t('sharelabel_tooltip')"
                />
                <label>{{ $t('sharelabel') }}</label>
              </div>
              <!--Tooltip :title="$t('sharelabel_tooltip')" /--->
            </div>
            <p
              v-if="submitted && errors.has('sharelabel')"
              class="error_message"
            >{{ errors.first('sharelabel') }}</p>
          </div>


<div class="col-3 mb-3">
            <div class="d-flex align-items-center">
              <div class="dropdown-curve-container">
                <label
                  :class="distributorShareType.dst_percentage_of.length > 0 ? 'shift-up' : '' "
                >{{ $t('percentgeOf') }}</label>
                <b-dropdown
                  :text="distributorShareType.dst_percentage_of"
                  variant="dropdown-curve"
                  class="w-100"
                  name="selectpercentage"
                  id="selectpercentage"
                  v-b-tooltip.hover
                  :title="$t('percentageof_tooltip')"
                >
                  <!-- v-validate="'required'" -->
                  <b-dropdown-item v-on:click="onSelectPercentage($event,'Net Amount')">Net Amount</b-dropdown-item>
                  <b-dropdown-item
                    v-on:click="onSelectPercentage($event,'Gross Amount')"
                  >Gross Amount</b-dropdown-item>
                </b-dropdown>
              </div>
              <!--Tooltip :title="$t('percentageof_tooltip')" /-->
            </div>
            <p
              v-if="submitted && distributorShareType.dst_percentage_of.length === 0"
              class="error_message"
            >{{ messagepercentage }}</p>
          </div>


 <div class="col-3 mb-3">
            <div class="d-flex align-items-center">
              <div class="dropdown-curve-container">
                <label
                  :class="distributorShareType.dst_duration.length > 0 ? 'shift-up' : '' "
                >{{ $t('duration') }}</label>
                <b-dropdown
                  :text="distributorShareType.dst_duration"
                  variant="dropdown-curve"
                  class="w-100"
                  name="selectduration"
                  id="selectduration"
                  v-b-tooltip.hover
                  :title="$t('duration_tooltip')"
                >
                  <!-- v-validate="'required'" -->
                  <b-dropdown-item v-on:click="onSelectDuration($event,'Daily')">Daily</b-dropdown-item>
                  <b-dropdown-item v-on:click="onSelectDuration($event,'Weekly')">Weekly</b-dropdown-item>
                </b-dropdown>
              </div>
              <!--Tooltip :title="$t('duration_tooltip')" /-->
            </div>
            <p
              v-if="submitted && distributorShareType.dst_duration.length === 0"
              class="error_message"
            >{{ messageduration }}</p>
          </div>


 <div class="col-3 mb-3">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  v-model="distributorShareType.dst_share_type_description"
                  type="text"
                  placeholder="."
                  name="dst_share_type_description"
                  id="dst_share_type_description"
                  v-validate="'required'"
                  v-b-tooltip.hover
                  :title="$t('dst_share_type_description_tooltip')"
                />
                <label>{{ $t('EnterMessage') }}</label>
              </div>
              <!--Tooltip :title="$t('dst_share_type_description_tooltip')" /-->
            </div>
            <p
              v-if="submitted && errors.has('dst_share_type_description')"
              class="error_message"
            >{{ errors.first('dst_share_type_description') }} sss</p>
          </div>

          <div class="col-9 d-flex" style="flex-wrap:wrap">

          <div class="col-4 mb-3 mt-2 align-self-center">
            <div class="d-flex">
              <p class="mb-0 mr-3">{{ $t('fixedValueToTheatre') }}</p>
              <b-form-checkbox
                unchecked-value="N"
                value="Y"
                v-model="distributorShareType.dst_fixed_value_to_theatre"
                name="check-button"
                class="j-checkbox mb-0"
              ></b-form-checkbox>
            </div>
          </div>

          

          <div class="col-4 mb-3 mt-2 align-self-center">
            <div class="d-flex justify-content-start">
              <p class="mb-0 mr-3">{{ $t('isPercentageValue') }}</p>
              <b-form-checkbox
                unchecked-value="N"
                value="Y"
                v-model="distributorShareType.dst_is_percentage"
                name="check-button"
                class="j-checkbox mb-0"
              ></b-form-checkbox>
            </div>
          </div>

         

          <div class="col-4 mb-3 mt-2 align-self-center">
            <div class="d-flex justify-content-start">
              <p class="mb-0 mr-3">{{ $t('active') }}</p>
              <b-form-checkbox
                v-model="distributorShareType.dst_is_active"
                unchecked-value="N"
                value="Y"
                name="check-button"
                class="j-checkbox mb-0"
              ></b-form-checkbox>
            </div>
          </div>


          </div>
         

          <div class="col-12 text-center">
            <button
              :disabled="btenable"
              @click.prevent.stop="onFinalSubmit"
              class="btn-blue"
            >{{ $t('save') }}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import DistributorService from "@/services/DistributorService";

export default {
  data() {
    return {
      btenable: false,
      messagepercentage: "Please Select Percentage Of.",
      messageduration: "Please Select Duration.",
      submitted: false,
      // Saif
      distributorShareType: {
        dst_id: null,
        dst_label: "",
        dst_fixed_value_to_theatre: "Y",
        dst_percentage_of: "Select Percentage Of",
        dst_is_percentage: "Y",
        dst_duration: "Select Duration",
        dst_is_active: "Y",
        dst_share_type_description: ""
      },

      // Saif
      checked: "y",
      percentageOf: "",
      shareDuration: ""
    };
  },
  beforeMount() {
    const { id } = this.$route.query;
    console.log("this.$route.query :", this.$route.query);
    if (id) {
      this.getEditDistributorList(id);
    } else {
      this.$router.go(-1);
    }
  },
  mounted() {},
  methods: {
    // Saif
    getEditDistributorList: function(dst_id) {
      // dst_id
      DistributorService.GetDistributorShareTypeById({ dst_id })
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.distributorShareType = data.Records[0];
          } else {
            this.$toasted.show(
              data.message ||
                "Sorry! Something went wrong. kindly contact your administrator"
            );
          }
        })
        .catch(this._CatchError);
    },

    onSelectPercentage: function(event, params) {
      this.distributorShareType.dst_percentage_of = params;
    },
    onSelectDuration: function(event, params) {
      this.distributorShareType.dst_duration = params;
    },
    onFinalSubmit: function() {
      this.submitted = true;
      this.$validator.validate().then(valid => {
        console.log("valid :", valid);
        if (valid) {
          this.btenable = true;
          DistributorService.updateDistributorShareType(
            this.distributorShareType
          )
            .then(response => {
              this.btenable = false;
              const { data } = response;
              if (data && data.status) {
                this.$router.push({
                  path: "/distributor/distributor-share-type"
                });
              } else {
                this.$toasted.show(
                  data.message ||
                    "Sorry! Something went wrong. kindly contact your administrator"
                );
              }
            })
            .catch(this._CatchError); //message
        }
      });
    }
    // Saif
    // onSelectPercentage: function(params) {
    //   this.percentageOf = params;
    // },
    // onSelectDuration: function(params) {
    //   this.shareDuration = params + " ";
    // }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Pages/DistributorContainer/DistributorShareTypeComponents/editDistributorShareType.vue